import Vue from 'vue'

import HilightHero from '@/views/parts/HilightHero.vue'
import ItemNewsList from '@/views/parts/ItemNewsList.vue'
import itemSmallList from '@/views/parts/ItemSmallList.vue'
/* Script */

Vue.config.productionTip = false

if (document.getElementById('hilight-hero')) {
  new Vue({
    render: h => h(HilightHero)
  }).$mount('#hilight-hero')
}

if (document.getElementById('item-news-list')) {
  new Vue({
    render: h => h(ItemNewsList)
  }).$mount('#item-news-list')
}

if (document.getElementById('items-small-list')) {
  new Vue({
    render: h => h(itemSmallList)
  }).$mount('#items-small-list')
}
